let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4yXZx")).then(() => parcelRequire('YWyca'));